export default __webpack_public_path__ + "static/media/020-shopping bag.70f8e4d3.svg";